// extracted by mini-css-extract-plugin
export var container = "_5a-0";
export var icon = "_5a-1";
export var text = "_5a-2";